import { keepPreviousData, useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiAnalysisInsightsShow } from '@/types/serializers';

// インサイトAPIのクエリパラメータ型（FunnelQueryParams のサブセット）
export interface InsightQueryParams {
  from: string;
  to: string;
  granularity: 'day' | 'week' | 'month';
  metric: 'uu' | 'count';
  count_mode: 'total' | 'registered_cohort';
  group_by?: 'candidate_user';
  filter_organization_user_ids?: number[];
  filter_target: 'candidate' | 'company';
  filter_company_tag_ids?: number[];
  filter_job_tag_ids?: number[];
  filter_candidate_tag_ids?: number[];
}

/**
 * 分析インサイトデータを取得するカスタムフック。
 * Funnel フックと同じく TanStack Query で1リクエスト分のキャッシュを管理する。
 */
export default function useFetchAnalysisInsight(
  params: InsightQueryParams,
  options?: { enabled?: boolean }
) {
  const query = qs.stringify(params, { arrayFormat: 'brackets' });

  return useQuery<AgentApiAnalysisInsightsShow>({
    queryKey: ['/agent/api/analysis/insight', query],
    queryFn: async () => {
      const response = await fetch(`/agent/api/analysis/insight.json?${query}`);
      if (!response.ok) {
        throw new Error('インサイトデータの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiAnalysisInsightsShow>;
    },
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}
